import Cookies from 'js-cookie';
import MicroModal from 'micromodal';


// Popup with image
let in30Minutes = 1 / 48;
const popupCloseBtn = document.getElementById('popupClose');
if (Cookies.get('popup_hidden') === undefined && popupCloseBtn) {
    setTimeout(function () {
        MicroModal.show('popup', {
            disableScroll: true,
            onShow: modal => {
                modal.scrollTo(0, 0);
            },
            onClose: modal => {
                Cookies.set('popup_hidden', true, { expires: 30 });
                modal.scrollTo(0, 0);
            }
        });
    }, 500);
}

// Popup on init with delay
const popupContactForm = document.querySelector('#popupContactForm');
if (popupContactForm) {
    const delayTime = popupContactForm.getAttribute('data-popup-init-delay');
    setTimeout(function () {
        MicroModal.show('popupContactForm', {
            disableScroll: true,
            onShow: modal => {
                modal.scrollTo(0, 0);
            },
            onClose: modal => {
                modal.scrollTo(0, 0);
            }
        });
    }, parseInt(delayTime) * 1000);
}